module.exports = __webpack_public_path__ + "desktop_70x70.4ecb73b7268db2128254610184b8f288.png";